import { IsSponsorEmployee } from '../../../../shared/src/types/sponsorEmployee/types'

export const isSponsorEmployee: IsSponsorEmployee = () => false
